<template>
  <div :style="userStyle">
    <video-player
      v-if="videoLoaded"
      v-bind:style="{ overflow: 'hidden', borderWidth: border.borderWidth + 'px', borderRadius: border.radius + 'px', borderColor: border.borderColor, borderStyle: border.borderStyle  }"
      :options="playerOptions"
      class="vjs-matrix vjs-big-play-centered"
      :class="{ 'controlBg': !controlBg }"
      ref="videoPlayer"
      :playsinline="true"
      @ready="playerReadied"
    />
  </div>
</template>
<script>
import axios from "axios";
import { videojs, videoPlayer } from "vue-video-player";
import watermark from "videojs-watermark";
videojs.registerPlugin("watermark", watermark);

export default {
  components: {
    videoPlayer
  },
  data: () => ({
    videoLoaded: false,

  elementColor: "#fff",
    
// watermark
    showWatermark: false,
    watermark: require("@/assets/logo.png"),
    watermarkPosition: "bottom-left",
    watermarkUrl: undefined,


    playerOptions: {
      aspectRatio: "16:9",
      autoplay: false,
      controls: true,
      muted: false,
      loop: false,
      language: "en",
      preload: "auto",
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [
        {
          type: "video/mp4",
          src: ""
        }
      ],
      controlBar: {
        // Hide and show time
        currentTimeDisplay: true,
        // should be default values and not saved in db
        timeDivider: false,
        durationDisplay: false,
        remainingTimeDisplay: false,

        // FUll SCRENN button
        fullscreenToggle: true,

        // Video timeline
        progressControl: true,

        // audo control
        volumePanel: true,

        playToggle: true,

        playbackRateMenuButton: true
      }

      // poster: "/static/images/author.jpg"
    },
    // border and radius
    border: {
      borderWidth: 0,
      borderColor: "#525252",
      borderStyle: "solid",
      radius: 0
    }
  }),

 computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    userStyle () {
    return {
      '--element-color': this.elementColor
    }
  }
  },
  async created() {
    await axios
      .get(`${process.env.VUE_APP_API_URL}/api/videos/${this.$route.params.id}`)
      .then(res => {
        this.playerOptions.sources[0].src = `${process.env.VUE_APP_API_URL}/api/videos/watch/${this.$route.params.id}`;
        this.playerOptions.autoplay = res.data.autoplay;
        this.playerOptions.controls = res.data.controls;
        this.playerOptions.muted = res.data.muted;
        this.playerOptions.loop = res.data.loop;
        // this.playerOptions.poster = `${process.env.VUE_APP_API_URL}/${res.data.poster}`;

        this.border.borderWidth = res.data.borderWidth;
        this.border.borderColor = res.data.borderColor;
        this.border.borderStyle = res.data.borderStyle;
        this.border.radius = res.data.radius;

        if(res.data.showPoster) {
          this.playerOptions.poster = `${process.env.VUE_APP_API_URL}/${res.data.poster}`;
        }

        this.playerOptions.controlBar.currentTimeDisplay =
          res.data.currentTimeDisplay;
        this.playerOptions.controlBar.fullscreenToggle =
          res.data.fullscreenToggle;
        this.playerOptions.controlBar.progressControl =
          res.data.progressControl;
        this.playerOptions.controlBar.volumePanel = res.data.volumePanel;
        this.playerOptions.controlBar.playToggle = res.data.playToggle;
        this.playerOptions.controlBar.playbackRateMenuButton =
          res.data.playbackRateMenuButton;

        (this.showTitle = res.data.showTitle),
          (this.controlBg = res.data.controlBg),
          (this.videoLoaded = true);

                   // watermark
        this.showWatermark = res.data.showWatermark;
        this.watermark = `${process.env.VUE_APP_API_URL}/${res.data.watermark}`;
        this.watermarkPosition = res.data.watermarkPosition;
        this.watermarkUrl = res.data.watermarkUrl;
        this.elementColor = res.data.elementColor;
              
      })
      .catch(error => {
        console.log(error);
        this.$router.push({ name: "404" });
      });
  },
 methods: { 
    playerReadied(player) {
      if(this.showWatermark) {
        this.player.watermark({
            position: this.watermarkPosition,
            fadeTime: null,
            url: this.watermarkUrl,
            image: this.watermark,
          })
      }
    },
 }
};
</script>

<style lang="scss">
.controlBg {
  .vjs-control-bar {
    background: none !important;
  }
}
.vjs-watermark-content {
  img {
    max-width: 60px; 
  }
}


.vjs-matrix .vjs-button > .vjs-icon-placeholder:before,
.vjs-matrix .vjs-playback-rate,
.vjs-matrix.video-js{
    color: var(--element-color);
}
/* Change the border of the big play button. */
.vjs-matrix .vjs-big-play-button {
  border-color: var(--element-color);
}

/* Change the color of various "bars". */
.vjs-matrix .vjs-volume-level,
.vjs-matrix .vjs-play-progress,
.vjs-matrix .vjs-slider-bar {
  background: var(--element-color);
}
</style>
